export class UploadingFile {
	file: File;
	progress: number;
	uploading: boolean;
	errors: string | null;
}
